import { createContext, useState } from 'react';

import { end } from '@utils/Math/paginate';

export const LoadMoreContext = createContext<null | LoadMoreCtx>(null);
export interface LoadMoreCtx {
  /** hasMore */
  hasNextPage: boolean;
  /** loadMore */
  fetchNextPage: VoidFunction;
  /** What to show at end. Default is "End of list" */
  loadMoreText?: string;
  /** Element to check visibility against */
  root?: HTMLElement | null;
}
type UseVirtualPagesReturn<NeededData> = {
  loadMoreCtx: LoadMoreCtx | null;
  slice: NeededData[];
};

/** Nb: This is used for the inventory page */
export function useVirtualPages<NeededData>(
  fullThing: NeededData[],
  pageSize = 20,
  loadMoreOpts: Partial<LoadMoreCtx> = {},
  defaultCtx: LoadMoreCtx | null = null,
): UseVirtualPagesReturn<NeededData> {
  const [currentPage, setCurrentPage] = useState(1);
  const slice = fullThing.slice(0, end(currentPage, pageSize));
  const loadMoreCtx: LoadMoreCtx | null =
    slice.length === 0
      ? defaultCtx
      : {
          hasNextPage: slice.length < fullThing.length,
          fetchNextPage: () => setCurrentPage(prev => prev + 1),
          ...loadMoreOpts,
        };
  return { loadMoreCtx, slice };
}
